export default "/images/a3ce9b19b63ea0dc247527727a96f4b4.avif";